module.exports = __webpack_public_path__ + "static/media/clock-minus.e3a029ed.svg";